<template>
  <div class="add-to-home-screen">
    <transition name="slide">
      <div v-if="showInstruction" class="add-to-home-screen__instruction">
        <Instruction />
      </div>
    </transition>

    <button class="add-to-home-screen__button" @click="toggleShowInstruction">
      Tải app về máy
    </button>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import Instruction from "./Instruction.vue";

@Options({
  components: {
    Instruction
  }
})
export default class AddToHomeScreen extends Vue {
  showInstruction = false;

  toggleShowInstruction() {
    this.showInstruction = !this.showInstruction;
  }
}
</script>

<style lang="scss" scoped>
.add-to-home-screen {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.add-to-home-screen__button {
  width: 100%;
  height: 50px;
  outline: none;
  border: none;
  background: $warning-color;
  color: $white;
}

.add-to-home-screen__instruction {
  height: 50vh;
}

.slide-enter-active {
  transition-timing-function: ease-in;
  transition-duration: 0.3s;
}

.slide-leave-active {
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-duration: 0.3s;
}

.slide-enter-to,
.slide-leave-from {
  overflow: hidden;
  max-height: 50vh;
}

.slide-enter-from,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
